<template>
  <div>
    <WallkitPlanView :editing="true"/>
  </div>
</template>


<script>
import WallkitPlanView from "./WallkitPlanView";
export default {
  name: "WallkitPlanEditing",
  components: {WallkitPlanView}
}
</script>
